// Import CSS
import "../css/index.css";

// Import JS
import 'flickity-fade';
import 'flickity-as-nav-for';
import Flickity from 'flickity';
import InfiniteScroll from 'infinite-scroll';


// Get light or dark contrast.
function getContrast(t){return"#"===t.slice(0,1)&&(t=t.slice(1)),3===t.length&&(t=t.split("").map(function(t){return t+t}).join("")),128<=(299*parseInt(t.substr(0,2),16)+587*parseInt(t.substr(2,2),16)+114*parseInt(t.substr(4,2),16))/1e3?"light":"dark"}

// Convert the RGB color to hex.
function rgbaToHex(rgba) {
    const values = rgba.match(/[\.\d]+/g);
    if (!values) return null;

    const alpha = values.length === 4 ? Math.round(parseFloat(values[3]) * 255).toString(16).padStart(2, '0') : '';
    return `#${values.slice(0, 3).map(val => Math.round(parseFloat(val)).toString(16).padStart(2, '0')).join('')}${alpha}`;
}

// Apply Theme Styles.
export function applyThemeStyles(){
    let themeAccentStyle = 'accent-' + getContrast( themeSettings.accentColor );
    document.getElementsByTagName('body')[0].classList.add( themeAccentStyle );

    return "Styles Generated";
}
window.applyThemeStyles = applyThemeStyles;

document.addEventListener('DOMContentLoaded', function () {
    applyThemeStyles();
    initializeVideoContainers();
}, false);

/**
 * Fade In Tech
 */
document.addEventListener("DOMContentLoaded", () => {
    const fadeElements = document.querySelectorAll(".ct-fade-in-up, .ct-fade-in-down, .ct-fade-in");

    const handleScroll = () => {
        fadeElements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                el.classList.add("ct-transition");
            }
        });
    };

    // Trigger on scroll and initial load
    window.addEventListener("scroll", handleScroll);
    handleScroll();
});

/**
 * Universal Video System - Handles Vimeo, YouTube, and self-hosted videos
 */
function initializeVideoContainers() {
    const videoContainers = document.querySelectorAll('[data-video-src]');
    videoContainers.forEach(function(container) {
        const videoSrc = container.getAttribute('data-video-src');
        if (!videoSrc) return;

        // Detect video type and create appropriate element
        if (videoSrc.includes('vimeo.com')) {
            const videoId = videoSrc.match(/vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/)?.[3];
            if (videoId) {
                const iframe = document.createElement('iframe');
                iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&background=1&controls=0&title=0&byline=0&portrait=0`;
                iframe.allow = 'autoplay; fullscreen; picture-in-picture';
                iframe.allowFullscreen = true;
                container.appendChild(iframe);
            } else {
                console.warn(`Your Vimeo URL ${videoSrc} is invalid, please check it again.`);
            }
        } else if (videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be')) {
            const videoId = videoSrc.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/)?.[1];
            if (videoId) {
                const iframe = document.createElement('iframe');
                iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&mute=1&controls=0&showinfo=0&rel=0&modestbranding=1&playlist=${videoId}`;
                iframe.allow = 'autoplay; fullscreen; picture-in-picture';
                iframe.allowFullscreen = true;
                container.appendChild(iframe);
            } else {
                console.warn(`Your Youtube URL ${videoSrc} is invalid, please check it again.`);
            }
        } else {
            // Self-hosted video
            const video = document.createElement('video');
            video.autoplay = true;
            video.loop = true;
            video.muted = true;
            video.playsInline = true;

            const source = document.createElement('source');
            source.src = videoSrc;
            source.type = 'video/mp4';

            video.appendChild(source);
            container.appendChild(video);
        }
    });
}

/**
 * Flickity Sliders.
 */

// Popular Tags.
document.querySelectorAll('.ct-popular-tags').forEach(element => {
    const tagsFlickity = new Flickity( element, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true,
    });
});

/**
 * Enable Post Share Button.
 */
import ClipboardJS from 'clipboard';
new ClipboardJS("#copy");

/**
 * Sticky Header.
 */
window.addEventListener("scroll", function() {
    var scrollAmount = window.pageYOffset,
        ctHeaderStuck = false,
        ctHeader = document.getElementById('ct-header'),
        ctBusyScrolling;

    if( !document.body.classList.contains( 'allow-sticky' ) ) return;

    /* Sticky Header */
    clearTimeout(ctBusyScrolling);
    ctBusyScrolling = setTimeout(function () {
        if (scrollAmount > 160 && !ctHeaderStuck ) {
            ctHeaderStuck = true;
            document.body.classList.add('header-sticky');
            setTimeout(function() { // This timeout ensures the class is added just after 'header-sticky' is applied
                ctHeader.classList.add('visible');
            }, 500); // A slight delay to ensure the order of operations
        } else {
            ctHeader.classList.remove('visible');
            document.body.classList.remove('header-sticky');
        }
    }, 250);
});

/**
 * Infinite Scroll Load More Button.
 */
document.addEventListener("DOMContentLoaded", function() {
    const button = '.ct-load-more',
        loadMoreButtons = document.querySelectorAll(button );

    loadMoreButtons.forEach((loadMoreButton) => {
        const container = loadMoreButton.getAttribute('data-container'),
            list = loadMoreButton.getAttribute('data-list'),
            item = loadMoreButton.getAttribute('data-item');

        if ( ! ( container || list || item ) ) {
            console.log('Fail InfiniteScroll Setup!');
            return;
        }

        var infScroll = new InfiniteScroll(`${container} ${list}`, {
            path: `${container} ${button}`,
            button: `${container} ${button}`,
            append: `${container} ${list} ${item}`,
            history: false,
            scrollThreshold: false
        });

        infScroll.on('append', function(response, path, items) {
            for (var i = 0; i < items.length; i++) {
                reloadSrcsetImgs(items[i]);
            }
        });
    });

    function reloadSrcsetImgs(item) {
        var imgs = item.querySelectorAll('img[srcset]');
        for (var i = 0; i < imgs.length; i++) {
            var img = imgs[i];
        }
    }
});
